import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { SPACE_SERVICE } from '@eggplant/api-hosts'
import type { GetSpacesResponse } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  children?: (response: GetSpacesResponse) => ReactElement
  onSuccess?: (data: GetSpacesResponse) => void
}

const GetSpacesRequest = ({
  onSuccess,
  children
}: Props) => {
  const url = `${SPACE_SERVICE}/spaces`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetSpacesRequest
